import React from 'react';
import { connect } from 'react-redux'
import {mapSearchResultsStateToProps, SearchResultsContainer, PageContainer, PageContainerNoHeader} from './primary'
import {SagaSearchResult} from '../components/SearchResult'
import {loadData} from '../utils/operations'
import NordenSearchForm, { nordenSearchDefaultValues } from '../components/NordenSearchForm'
import ISpan from "../i18n/ISpan";
import {changePageTitle} from "../i18n/localisations";
import defaults from "../utils/defaullts";
import {SearchResult} from '../components/SearchResult'


class NordenSearchResultsPage extends SearchResultsContainer{

    constructor(props){
        super(props);
        this.submit(nordenSearchDefaultValues)
        this.props.localise();
    }
    render(){
        return super.render();
    }

    submit = (values) =>{
        SearchResultsContainer.submit(values);
        this.props.loadData(values);
    };

    getSearchResult(result) {
        return <SearchResult key={Math.random()} item={result} />
    }

    getSearchBlock() {
        return <div className={"five columns"}>
            <h2 className={"pane-title"} data-localize=""><ISpan localisationId="common.title.search_norden" defaultValue="Search Norden"/></h2>
            <p className="helptext" data-localize=""><ISpan localisationId="common.title.search_help_norden" defaultValue="Search for illustrator, author or motif. You can also search or filter search results by using the dropdowns."/></p>
            <NordenSearchForm onSubmit={this.submit}/>
        </div>
    }
}




NordenSearchResultsPage = connect(mapSearchResultsStateToProps,
    (dispatch) => {
        return {
            loadData: (searchValues) => dispatch(loadData(searchValues)),
            localise: () => dispatch(changePageTitle("common.title.norden_title", "Föreningen Norden"))
        }
    }

)(NordenSearchResultsPage);

//export let NordenPage = NordenSearchResultsPage;
export class NordenPage extends PageContainerNoHeader {
    render(){
        return <PageContainerNoHeader title="Föreningen Norden" titleKey="common.title.norden_title">
            <NordenSearchResultsPage/>
        </PageContainerNoHeader>
    }
}

export default class SagaPageContainer extends PageContainer{
    render(){
        return <PageContainer title="Föreningen Norden" titleKey="common.title.norden_title">
            <NordenSearchResultsPage/>
        </PageContainer>
    }
}



// WEBPACK FOOTER //
// ./src/views/norden.js